import { callGetApiToServer } from "../../callApi";

export async function getList(user_id, authtoken, skip = 0, limit = 10) {
  try {
    const header = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Bearer " + authtoken,
    };

    const endUrl = `v1/auth/user/ip/${skip}/${limit}?user_id=${user_id}`;

    const responseData = await callGetApiToServer(header, "GET", endUrl);

    return responseData;
  } catch (err) {
    throw err;
  }
}
